<template>
  <div class="app-layout">
    <main-header />
    <main role="main">
      <transition
        name="fade"
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <router-view />
      </transition>
    </main>
    <!-- <main-footer /> -->
  </div>
</template>

<script>
import MainHeader from './Header';
// import MainFooter from './Footer';

export default {
  components: {
    MainHeader
    // MainFooter
  }
};
</script>

<style lang="scss" scoped>
.app-layout {
  @include themify($themes) {
    @include import-url(themed('fontFamilyUrl'));
    font-family: themed('fontFamily');
  }
  -webkit-box-shadow: 0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108);
  -moz-box-shadow: 0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108);
  background: $color-white;
  box-shadow: 0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108);
  font-family: $font-family;
  max-width: 1280px; // Número mágico que nos ha dado ALD
  width: 100%;
  min-height: 100vh;

  h1 {
    @include themify($themes) {
      @include import-url(themed('fontFamilyUrlH1'));
      font-family: themed('fontFamilyH1');
    }
  }

  main {
    min-height: calc(100vh - 120px);
    position: relative;
    .main-content {
      padding-top: 16px;
    }
  }
}
</style>
